import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import Footer from '@/components/common/Footer';

export function AppLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const closeMobileNav = () => setMobileNavOpen(false);

  return (
    <div className="app-shell" data-theme="swayam-preview">
      <Sidebar
        mobileNavOpen={mobileNavOpen}
        onCloseMobileNav={closeMobileNav}
      />
      <div className="app-content-shell">
        <Header onToggleMobileNav={() => setMobileNavOpen((o) => !o)} />
        <main className="app-main">
          <Outlet />
        </main>
        <Footer />
      </div>
      {mobileNavOpen && (
        <div
          className="mobile-nav-backdrop"
          onClick={closeMobileNav}
          aria-hidden="true"
        />
      )}
    </div>
  );
}
